import api from '@/apis/di/budgetFeesAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid Khoản
export const useBudgetFeesComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();
  // func call api lấy dữ liệu combo
  const onBudgetFeesComboboxLoadData = (payload, row, column) => {
    payload.sort = 'budget_fees_code';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const budgetFeesComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã phí, lệ phí',
        dataField: 'budget_fees_code',
        width: 150,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên phí, lệ phí',
        dataField: 'budget_fees_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 450,
      },
    ],
    displayField: 'budget_fees_code',
    valueField: 'budget_fees_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onBudgetFeesComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return {
    budgetFeesComboConfig,
    onBudgetFeesComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
